import React from 'react';
import { SIGNUP_INPUT_STYLE } from './emailSignup.js';

// Presentational name + email form shared by the waitlist and news-list
// signups. Stateless: the parent owns name/email/error/submitting and the
// submit handler, so each use site keeps its own success semantics (the
// waitlist sets a cookie; the news list shows a "check your email" message).
const EmailNameForm = ({
  name,
  email,
  onNameChange,
  onEmailChange,
  error,
  submitting,
  submitLabel = 'Submit',
  submittingLabel = 'Submitting…',
  submitStyle,
  onSubmit,
}) => {
  // Submit on Enter from either field.
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      <input
        type="text"
        aria-label="Your name"
        placeholder="Your Name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={100}
        style={SIGNUP_INPUT_STYLE}
      />
      <input
        type="email"
        aria-label="Email address"
        placeholder="Email Address"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={254}
        style={SIGNUP_INPUT_STYLE}
      />

      {error && <p style={{ color: '#b00020', fontSize: '14px', margin: 0 }}>{error}</p>}

      <button type="button" onClick={onSubmit} disabled={submitting} style={submitStyle}>
        {submitting ? submittingLabel : submitLabel}
      </button>
    </div>
  );
};

export default EmailNameForm;
